import React from 'react';

import {cx} from '../../util';
import Pill from './Pill';

/** Small pill badge, e.g. <Badge>Asked at Google</Badge> in practice cards. */
export const Badge = ({children}) => (
  <Pill color="indigo" className="align-middle font-medium">{children}</Pill>
);

const DIFFICULTY_COLORS = {
  easy: 'emerald',
  medium: 'amber',
  hard: 'rose',
};

/**
 * One practice question / lesson row: title, optional difficulty pill
 * (Easy | Medium | Hard), optional company badge, and a one-line hook
 * (children). Cards stack — no grid or wrapper needed. With an href the
 * entire card is clickable (with a subtle hover state); without one it
 * renders as a dashed "Planned" row.
 */
export const LessonCard = ({
  title,
  href,
  difficulty,
  badge,
  children,
}) => {
  const planned = !href;
  const body = (
    <>
      <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1.5">
        <span className={cx(
          'font-semibold tracking-tight',
          planned ? 'text-gray-600' : 'text-gray-900 group-hover:text-indigo-700',
        )}
        >
          {title}
        </span>
        {difficulty && (
          <Pill color={DIFFICULTY_COLORS[String(difficulty).toLowerCase()]} className="font-medium">
            {difficulty}
          </Pill>
        )}
        {badge && <Badge>{badge}</Badge>}
        {planned && <Pill className="font-medium">Planned</Pill>}
      </div>
      {children && (
        <div className="mt-1 text-[0.95em] leading-[1.65] text-gray-600 [&_p]:my-0">
          {children}
        </div>
      )}
    </>
  );

  if (planned) {
    return (
      <div className="my-3 rounded-xl border border-dashed border-gray-300 px-5 py-4">
        {body}
      </div>
    );
  }

  return (
    <a
      href={href}
      className="group my-3 block rounded-xl border border-gray-200 bg-white px-5 py-4 no-underline shadow-xs transition-all duration-150 hover:border-indigo-200 hover:shadow-sm"
    >
      {body}
    </a>
  );
};

export default LessonCard;
